import {
  BYSTADIUM_DASHBOARD_HOSTNAME,
  LOCKER_DASHBOARD_URL,
  STADIUM_USERS_URL,
  BYSTADIUM_MARKETING_URL,
  BYSTADIUM_HOSTNAME,
} from "@stadium/helpers/src/app-routes";

import { generateUrlByQuery } from "@stadium/helpers/dom";
import { MY_WORKSPACE_SLUG, DEFAULT_WORKSPACE_ROUTE } from "@stadium/constants";

export const SHOPS_DASHBOARD_URL = `${BYSTADIUM_DASHBOARD_HOSTNAME}/shops`;
export const STADIUM_LOCKER_DASHBOARD_URL = LOCKER_DASHBOARD_URL;
export const P2P_LANDING_PAGE_URL = `${BYSTADIUM_DASHBOARD_HOSTNAME}/recognition`;

export const CREATE_KUDOS_PROGRAM_PATH = "/recognition/programs/new";
export const KUDOS_PROGRAM_FEED_PATH = "/recognition/programs/[number]/feed";

export const P2P_LISTING_PAGE_URL = `${BYSTADIUM_DASHBOARD_HOSTNAME}/recognition/programs/list`;
export const HOLIDAY_OFFERINGS = `${BYSTADIUM_MARKETING_URL}/holiday-gifting`;
export const RECIPIENT_SEND_POINTS_ROUTE = `${BYSTADIUM_DASHBOARD_HOSTNAME}/default/shops/orders/create/budget`;
export const PRODUCT_CUSTOMIZE_ROUTE = `${BYSTADIUM_DASHBOARD_HOSTNAME}/[workspaceSlug]/shops/product/[slug]`;

export const MEMBER_DETAILS = "member-details";
export const WALLET_SUMMARY = "summary";
export const WALLET_SUMMARY_ROUTE = `/${WALLET_SUMMARY}`;

const PATHNAMES = {
  settings: {
    home: "/account/settings",
    addressBook: "/account/address-book",
    paymentMethods: "/account/payment-methods",
    advancedOptions: "/account/advanced-options",
    changePassword: "/account/change-password",
    emailPreferences: "/account/email-preferences",
    tasteProfile: "/account/taste-profile",
    contacts: "/account/contacts",
  },
  eshops: {
    base: "/shops",
    home: "/shops",
    myShops: "/shops/[[...status]]",
    redeem: "/shops/redeem",
    shopPage: "/shops/[code]",
    myOrders: "/my-orders",
    purchases: "/my-orders/purchases",
    integrations: "/integrations",
    availableShops: "/redeem",
    chooseTemplate: "/templates",
    createShop: "/create",
    editTemplate: "/create/edit-template",
    myFunds: "/my-funds",
    kits: "/kits",
    live: "/live",
    resources: "/resources",
    dashboard: "/dashboard",
    stadiumPointsHistory: "/points-history/stadium-points",
    campaigns: "/automated-gifting",
    companySpace: "/admin",
    sentGifts: "/my-orders/sent-gifts",
    recognition: "/recognition",
    recoginitionPrograms: "/recognition/programs/list",
    contacts: "/contacts-tab",
    orders: "/orders",
    assetLibrary: "/manage-assets",
  },
  users: {
    account: "/account",
    wallet: "/wallet",
    points: "/wallet/my-points",
    pointsSummary: `/wallet/my-points${WALLET_SUMMARY_ROUTE}`,
    defaultWallet: "/wallet/default",
  },
  locker: {
    locker: "/locker",
    lockerCollection: "/locker/collection",
    dashboard: "/",
    listing: "/",
    details: "/locker/[type]/[slug]",
    withWorkspaceTab: "/[workspaceSlug]/locker/[viewType]/[tab]",
    addToLocker: "/select-swag-add-type",
    saved: "/saved",
    inventory: "/inventory",
    collection: "/collection/[collectionId]",
    product: "/item/[productCatalogSlug]",
  },
  marketing: {
    launchpad: "/go",
    bookACall: "/go/book-a-call",
    partnerships: "/partnerships",
    api: "/api-integrations",
    resources: "/resources",
    thankYouPage: "/thank-you",
  },
};

export const { settings, eshops, users, locker, marketing } = PATHNAMES;

export const SETTINGS_PATHNAMES = Object.values(settings);
export const CHAT_BOT_OPEN = 'javascript:window?.zE?.("messenger", "open")';

//Users
export const WALLET_URL = `${STADIUM_USERS_URL}${users.defaultWallet}`;
export const ACCOUNT_SETTINGS_URL = `${STADIUM_USERS_URL}${settings.home}`;
export const ACCOUNT_CONTACTS_URL = `${STADIUM_USERS_URL}${settings.contacts}`;
export const WORKSPACE_WALLET_ROUTE = `${BYSTADIUM_DASHBOARD_HOSTNAME}${users.wallet}/[walletId]`;

export const MERGED_WALLET_URL = `${BYSTADIUM_DASHBOARD_HOSTNAME}${users.defaultWallet}`;
export const MERGED_ADD_FUNDS_URL = `${MERGED_WALLET_URL}?add-funds=true`;
export const MERGED_ACCOUNT_SETTINGS_URL = `${BYSTADIUM_DASHBOARD_HOSTNAME}${settings.home}`;
export const MERGED_ACCOUNT_CONTACTS_URL = `${BYSTADIUM_DASHBOARD_HOSTNAME}${settings.contacts}`;
export const ACCOUNT_ADVANCED_OPTIONS_URL = `${BYSTADIUM_DASHBOARD_HOSTNAME}${settings.advancedOptions}`;
export const POINTS_URL = `${BYSTADIUM_DASHBOARD_HOSTNAME}${users.points}`;

//Dashboard
export const MYSHOPS_URL = `${SHOPS_DASHBOARD_URL}${eshops.live}`;
export const EDIT_ESHOPS_TEMPLATE_URL = `${SHOPS_DASHBOARD_URL}${eshops.editTemplate}`;
export const CHOOSE_ESHOPS_TEMPLATE_URL = `${SHOPS_DASHBOARD_URL}${eshops.chooseTemplate}`;
export const MY_ORDERS_URL = `${SHOPS_DASHBOARD_URL}${eshops.myOrders}`;
export const INTEGRATIONS_URL = `${SHOPS_DASHBOARD_URL}${eshops.integrations}`;
export const KITS_DASHBOARD_ROUTE = `${SHOPS_DASHBOARD_URL}${eshops.kits}`;
export const SEND_ITEMS_ROUTE = `${KITS_DASHBOARD_ROUTE}?send-items=true`;
export const DASHBOARD_ROUTE = `${BYSTADIUM_DASHBOARD_HOSTNAME}${eshops.dashboard}`;
export const STADIUM_POINTS_HISTORY_URL = `${SHOPS_DASHBOARD_URL}${eshops.stadiumPointsHistory}`;
export const CAMPAIGNS_URL = `${BYSTADIUM_DASHBOARD_HOSTNAME}${eshops.campaigns}`;
export const WORKSPACE_CONTACTS_URL = `${BYSTADIUM_DASHBOARD_HOSTNAME}${eshops.contacts}`;
export const WORKSPACE_MANAGE_CONTACTS_URL = `${WORKSPACE_CONTACTS_URL}/manage-permissions`;
export const ASSET_LIBRARY_URL = `${BYSTADIUM_DASHBOARD_HOSTNAME}${eshops.assetLibrary}`;

export const COMPANY_SPACE_URL = `${BYSTADIUM_DASHBOARD_HOSTNAME}${eshops.companySpace}`;
export const COMPANY_SPACE_WORKSPACE_SETTINGS = `${eshops.companySpace}/settings`;
export const COMPANY_SPACE_BILLING = `${BYSTADIUM_DASHBOARD_HOSTNAME}${eshops.companySpace}/billing`;
export const COMPANY_SPACE_INTEGRATIONS = `${BYSTADIUM_DASHBOARD_HOSTNAME}${eshops.companySpace}/integrations`;
export const COMPANY_SPACE_SSO = `${BYSTADIUM_DASHBOARD_HOSTNAME}${eshops.companySpace}/sso`;

export const MY_PURACHES_URL = `${SHOPS_DASHBOARD_URL}${eshops.purchases}`;
export const SENT_GIFTS_PURACHES_URL = `${SHOPS_DASHBOARD_URL}${eshops.sentGifts}`;

//Locker
export const LOCKER_LISTING_URL = `${STADIUM_LOCKER_DASHBOARD_URL}${locker.listing}`;
export const LOCKER_SAVED_DESIGNS_URL = `${STADIUM_LOCKER_DASHBOARD_URL}${locker.saved}`;
export const LOCKER_INVENTORY_URL = `${STADIUM_LOCKER_DASHBOARD_URL}${locker.inventory}`;
export const LOCKER_PRODUCT_URL = `${STADIUM_LOCKER_DASHBOARD_URL}${locker.product}`;

//Shops Features Marketing
export const BYSTADIUM_PARTNERSHIPS_URL = `${BYSTADIUM_MARKETING_URL}${marketing.partnerships}`;
export const BYSTADIUM_API_INTEGRATION_URL = `${BYSTADIUM_MARKETING_URL}${marketing.api}`;
export const RESOURCES_URL = `${BYSTADIUM_MARKETING_URL}${marketing.resources}`;
export const THANK_YOU_PAGE_URL = `${BYSTADIUM_MARKETING_URL}${marketing.thankYouPage}`;
export const REDEEM_GIFT_CODE_BASE_ROUTE = "/go/redeem-gift-code";
export const REDEEM_GIFT_CODE_ROUTE = `${REDEEM_GIFT_CODE_BASE_ROUTE}/[token]`;

export const getStadiumRouteWithWorkspaceSlug = ({ workspaceSlug, pathname = eshops.dashboard }) =>
  `${BYSTADIUM_DASHBOARD_HOSTNAME}/${workspaceSlug}${pathname}`;

export const generateNewSwagFlowUrl = (workspaceSlug) => {
  const baseUrl = BYSTADIUM_HOSTNAME;
  return `${baseUrl}/w/${workspaceSlug}/design/swag`;
};

export const getRecipientSendPointsRoute = (shopNumber, workspaceSlug) => {
  const path = generateUrlByQuery({
    pathname: RECIPIENT_SEND_POINTS_ROUTE,
    query: { sourceShopNumber: shopNumber },
  });

  const replaceWith = workspaceSlug ? `/${workspaceSlug}` : "";

  return path.replace(DEFAULT_WORKSPACE_ROUTE, replaceWith);
};

export const getProductCustomizeRoute = (
  slug,
  workspaceSlug = MY_WORKSPACE_SLUG,
  additionalRedirectParams = {},
) =>
  generateUrlByQuery({
    pathname: PRODUCT_CUSTOMIZE_ROUTE,
    query: {
      slug,
      workspaceSlug,
      returnUrl: generateUrlByQuery({
        pathname: window.location.href,
        query: additionalRedirectParams,
      }),
    },
  });

export const getLockerProductRoute = (productCatalogSlug, variantId = "") =>
  `${LOCKER_PRODUCT_URL.replace(
    "[productCatalogSlug]",
    productCatalogSlug,
  )}?variant_id=${variantId}`;

export const getRedeemGiftCodeRoute = (number, giftCode = "") =>
  `${REDEEM_GIFT_CODE_BASE_ROUTE}/${number}?gc=${giftCode}`;
